<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs
      v-model="model"
      :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
    >
      <!-- INVESTOR WALLET TAB -->
      <v-tab
        class="px-0 ml-0"
        v-if="$canRoute('managers') > 0"
        :href="`#tab-1`"
      >
        Investor Wallet Info
      </v-tab>

      <!-- MANAGER WALLET TAB -->
      <v-tab
        v-if="$canRoute('managers') > 0"
        :href="`#tab-2`"
      >
        Manager Wallet Info
      </v-tab>

      <v-tabs-items v-model="model">
        <!-- INVESTOR TAB -->
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <InvestorWalletInfoTab />
          </v-card>
        </v-tab-item>

        <!-- MANAGER TAB -->
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <WalletInfoTab />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import WalletInfoTab from "@/components/MamWallet/WalletInfoTab.vue";
import InvestorWalletInfoTab from "@/components/MamWallet/InvestorWalletInfoTab.vue";

export default {
  name: "MamWalletTabs",

  data() {
    return {
      tab: null,
      model: "tab-2", // default = Investor Wallet
    };
  },

  components: {
    WalletInfoTab,
    InvestorWalletInfoTab,
  },
};
</script>
